<!-- Standalone nav bar - uses theme default (light bar in light mode, dark in dark mode) -->
<ion-tab-bar [class.standalone-nav-bar]="standalone">
	<ion-tab-button (click)="navigateTo('home', $event)" [class.tab-selected]="activeTab === 'home'">
		<ion-icon name="ponyplace-logo"></ion-icon>
		<ion-label>Home</ion-label>
	</ion-tab-button>

	<ion-tab-button (click)="navigateTo('chat', $event)" [class.tab-selected]="activeTab === 'chat'">
		<ion-icon name="chatbubble"></ion-icon>
		<ion-label>Chat</ion-label>
		<ion-badge *ngIf="unreadCount > 0" color="danger">{{ unreadCount }}</ion-badge>
	</ion-tab-button>

	<ion-tab-button (click)="onAddListing($event)">
		<ion-icon name="add-circle" color="primary" fill="clear" class="center-large-btn"></ion-icon>
	</ion-tab-button>

	<ion-tab-button (click)="navigateTo('account', $event)" [class.tab-selected]="activeTab === 'account'">
		<ion-icon name="person-circle-outline"></ion-icon>
		<ion-label>Account</ion-label>
	</ion-tab-button>

	<ion-tab-button (click)="navigateTo('settings', $event)" [class.tab-selected]="activeTab === 'settings'">
		<ion-icon name="settings-outline"></ion-icon>
		<ion-label>Settings</ion-label>
	</ion-tab-button>
</ion-tab-bar>

